module.exports = __webpack_public_path__ + "img/icon-arrow-cancel.dbf56cfa.svg";